/**
 * lib/planGate.ts
 * Whether this org bought SK Queue's WEBSITE.
 *
 * GET /v1/me carries `subscribed_products`: the product websites the org bought.
 * A plan can include Queue only so it works underneath (SK Salon and SK Fleet
 * run their waitlists on it) — the Queue API keeps serving that plan's
 * console, but the Queue admin website is not theirs to open. Such a user goes
 * to the platform's not-in-plan page instead (redirectToNotInPlan).
 *
 * This is NOT the surface entitlements in context/sessionContext (which tabs a
 * Queue customer sees); it only decides whether the admin shell opens at all.
 * Public surfaces (Guest QR, Now Serving) never reach it.
 *
 * Fails OPEN: a missing, null or malformed list means "no restriction". The
 * platform sends null while its PRODUCT_UI_GATE_ENABLED switch is off, for the
 * trial plan, and for Softknack staff. A wrong block locks a paying customer
 * out; a wrong allow does not.
 */

export const PRODUCT = 'queue';

export function isNotInPlan(subscribedProducts: unknown, product: string = PRODUCT): boolean {
  if (!Array.isArray(subscribedProducts)) return false;
  return !subscribedProducts.includes(product);
}
